<style>
    .btn-file {
        position: relative;
        overflow: hidden;
    }

        .btn-file input[type=file] {
            position: absolute;
            top: 0;
            right: 0;
            min-width: 100%;
            min-height: 100%;
            font-size: 100px;
            text-align: right;
            filter: alpha(opacity=0);
            opacity: 0;
            outline: none;
            background: white;
            cursor: inherit;
            display: block;
        }
</style>
<template>
    <div class="form-group ">
        <label class="col-md-3 control-label">Upload Image</label>
        <div class="col-md-9">
            <label class="btn btn-default btn-file col-md-3">
                Browse <input type='file' @change="fileChanged" accept="image/*" />
            </label>

            <div v-if="imageData.length > 0" class="col-md-9">
                <img id="blah" :src="imageData" class="img-thumbnail" style="max-width:200px"/>
            </div>

        </div>
    </div>
</template>
<script>

    import $ from 'jquery';

    export default {
        data: function () {
            return {
                imageData: ""
            }
        },
        methods: {
            fileChanged: function (event) {
                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.imageData = e.target.result;
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// formimageupload.scp.html?297907ca